import React, { useEffect, useMemo, useRef, useState } from "react";
import { Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner, ModalFooter } from "@/Components/ui";;

import { useNavigate } from "react-router-dom";
import BreadCrumb from "../../../Components/Common/BreadCrumb";

import toast, { Toaster } from 'react-hot-toast';

import Calendar from "react-calendar";

import { API_PACKAGE, API_PACKAGE_OFFDAYS, changeOffDay, createOffDay, deleteCancelDayById, getCancelDay, getDataFromUrl, postCancelDay } from "../../../api";
import moment from "moment";

import "react-calendar/dist/Calendar.css";
import "./style.css";
import SubCardTable from "./subCardTable";
import MyEditor from "../../../Components/editor/MyEditor";
import { dialogService } from "@/utils/dialogService";

function printDiv(elid) {
  var divContents = document.getElementById(elid).innerHTML;
  var a = window.open("", "", "height=700, width=500");
  a.document.write("<html>");
  a.document.write('<body><table class="custom-header-css table">');
  a.document.write(divContents);
  // console.log(divContents)
  a.document.write("</table></body></html>");
  a.document.close();
  a.print();
}

const ReservationCalendar = () => {
  const navigate = useNavigate();

  const today = useMemo(() => {
    return new Date();
  }, []);
  useEffect(() => {
    changeMonth(today);
  }, [today]);

  const [reservLoading, setReservLoading] = useState(false);

  const [value, onChange] = useState(new Date());
  const [showPackageInCalendar, setShowPackageInCalendar] = useState(false);
  const [reservDatas, setReservDatas] = useState({});
  const [showPrice, setShowPrice] = useState(false);
  const [bulkOffdayLoading, setBulkOffdayLoading] = useState(null);
  const [offdayRefreshKey, setOffdayRefreshKey] = useState(0);

  const [isCancelable, setIsCancelable] = useState(null);

  const [cancelDayModal, setCancelDayModal] = useState(false);
  const cancelDayModalToggle = () => setCancelDayModal(!cancelDayModal);
  const [cancelReason, setCancelReason] = useState("우천취소");
  const [cancelTitle, setCancelTitle] = useState("");
  const [cancelDescription, setCancelDescription] = useState("");
  const [cancelButtonName, setCancelButtonName] = useState("우천취소");

  const selectedDateText = useMemo(() => moment(value).format("YYYY-MM-DD"), [value]);
  const selectedDatePackages = useMemo(() => {
    const packages = reservDatas[selectedDateText];
    return Array.isArray(packages) ? packages : [];
  }, [reservDatas, selectedDateText]);
  const isPastSelectedDate = useMemo(() => {
    return moment(today).startOf("day").diff(moment(value).startOf("day"), "days") > 0;
  }, [today, value]);

  const changeMonth = (_target) => {
    if (!_target) {
      _target = new Date();
    }
    setReservLoading(true);
    // var lastDayOfMonth = new Date(_target.getFullYear(), _target.getMonth() + 1, 0);
    (async () => {
      const datas = await getDataFromUrl(`${API_PACKAGE}/status-montly/?year=${_target.getFullYear()}&month=${_target.getMonth() + 1}`);
      console.log(datas);
      if (datas && datas.result) {
        const _datas = {};
        for (let i = 0; i < datas.result.length; i++) {
          const _packages = datas.result[i]
          _datas[datas.result[i][0]["date"]] = _packages.filter((item) => {
            if (item.price > 0 || item.allow_free_booking) {
              return true;
            }
            return false;
          });
        }
        setReservDatas(_datas);
      }
      setReservLoading(false);
    })().catch((e) => {
      console.log(e);
    });
  };

  const addRainCancelDay = async (date, reason, buttonName, title, description) => {
    const datas = await postCancelDay(date, reason, buttonName, title, description);
    if (datas && datas.result) {
      toast.success("우천취소 날짜가 추가되었습니다.");
    }
    return datas;
  };

  const getPackageOffDay = async (packageId, dateText) => {
    const datas = await getDataFromUrl(`${API_PACKAGE_OFFDAYS}/?package=${packageId}&date=${dateText}`);
    if (Array.isArray(datas) && datas.length) {
      return datas[0];
    }
    return null;
  };

  const setPackageOffDay = async (packageId, dateText, dayoff) => {
    const currentOffDay = await getPackageOffDay(packageId, dateText);
    if (currentOffDay?.id) {
      return changeOffDay(currentOffDay.id, packageId, dateText, dayoff);
    }
    if (!dayoff) {
      return null;
    }
    return createOffDay(packageId, dateText, dayoff);
  };

  const handleBulkOffDay = async (dayoff) => {
    if (!selectedDatePackages.length) {
      toast.error("선택한 날짜에 예약 상품이 없습니다.");
      return;
    }

    const confirmed = await dialogService.confirm({
      title: dayoff ? "전체 예약 막기" : "예약 막음 풀기",
      description: `${selectedDateText} 예약 상품 ${selectedDatePackages.length}개의 예약 상태를 변경합니다.`,
      confirmLabel: dayoff ? "예약 막기" : "막음 풀기",
      cancelLabel: "닫기",
      tone: dayoff ? "destructive" : "warning",
      destructive: dayoff,
    });
    if (!confirmed) return;

    setBulkOffdayLoading(dayoff ? "block" : "unblock");
    try {
      await Promise.all(selectedDatePackages.map((item) => setPackageOffDay(item.id, selectedDateText, dayoff)));
      toast.success(dayoff ? `${selectedDateText} 전체 예약을 막았습니다.` : `${selectedDateText} 예약 막음을 풀었습니다.`);
      setOffdayRefreshKey((current) => current + 1);
      changeMonth(value);
    } catch (error) {
      console.warn(error);
      toast.error(dialogService.normalizeMessage(error) || "예약 상태 변경에 실패했습니다.");
    } finally {
      setBulkOffdayLoading(null);
    }
  };

  const handleDeleteCancelDay = () => {
    if (!isCancelable?.id) return;
    deleteCancelDayById(isCancelable.id)
      .then((data) => {
        console.log("cancel day deleted:", data);
        setIsCancelable(null);
        toast.success("우천취소 설정을 되돌렸습니다.");
      })
      .catch((error) => {
        console.warn(error);
        toast.error(dialogService.normalizeMessage(error) || "우천취소 되돌리기에 실패했습니다.");
      });
  };

  useEffect(() => {
    getCancelDay(moment(value).format("YYYY-MM-DD")).then((res) => {
      console.log("cancel day:", res);
      if (res && res.length) {
        setIsCancelable(res[0]);
      } else {
        setIsCancelable(null);
      }
    });
  }, [value]);

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title="예약현황관리" pageTitle="예약" />
        <Row>
          <Col lg={12}>
            <Card id="orderListCalendar" key={"orderListCalendar"}>
              <CardHeader className="card-header border-0">
                <div className="d-flex align-items-center">
                  <div className="card-title mb-0 flex-grow-1">
                    <h5>예약 현황</h5>
                    <div className="">
                      <input type="checkbox" id="showPackageInCalendar" name="showPackageInCalendar" checked={showPackageInCalendar} onChange={(e) => setShowPackageInCalendar(e.target.checked)} />
                      <label htmlFor="showPackageInCalendar" className="m-2">패키지 표시</label>

                      <input type="checkbox" id="showPrice" name="showPrice" checked={showPrice} onChange={(e) => setShowPrice(e.target.checked)} />
                      <label htmlFor="showPrice" className="m-2">가격표시</label>
                    </div>
                  </div>
                  <div className="flex-shrink-0">
                    {reservLoading ? (
                      <div style={{}}>
                        <Spinner color="primary"> Loading... </Spinner>
                        <span>데이터를 로딩하는 중입니다...</span>
                      </div>
                    ) : null}
                  </div>
                </div>
              </CardHeader>

              <CardBody className="pt-0">
                <div className="card-body pt-0">
                  <div>
                    <React.Fragment>
                      <Calendar
                        onChange={onChange}
                        value={value}
                        calendarType="US"
                        onClickMonth={(value) => {
                          changeMonth(value);
                        }}
                        onActiveStartDateChange={({ action, activeStartDate, value, view }) => {
                          console.log("Calendar onActiveStartDateChange:", action);
                          //"prev", "prev2", "next", "next2", "drillUp", "drillDown", "onChange".
                          if (view === "month") {
                            // if(action === "prev" || action === "next" || action === "prev2" || action === "next2" || action === "onChange" ) {
                            changeMonth(activeStartDate);
                            // }
                          }
                        }}
                        tileContent={({ activeStartDate, date, view }) => {
                          if (reservLoading) {
                            return <div>Loading...</div>;
                          }
                          if (!showPackageInCalendar) {
                            return null;
                          }
                          const datestring = moment(date).format("YYYY-MM-DD");
                          if (reservDatas[datestring]) {
                            // return <span>{reservDatas[datestring][0].name}</span>
                            return (
                              <>
                                {reservDatas[datestring]
                                  .filter((item) => item.price > 0)
                                  .sort((a, b) => {
                                    try {
                                      return a.name.localeCompare(b.name); // Then sort by name
                                    }
                                    catch (e) {
                                      return 0; // Fallback to no sorting if comparison fails
                                    }
                                  })
                                  .map((val, idx) => {
                                    const _price = showPrice ? `:: ${new Intl.NumberFormat().format(val.price)}` : "";
                                    if (val.price || val.allow_free_booking)
                                      return (
                                        <span key={idx} style={{ color: "#000" }}>
                                          <br />
                                          {`${val.name} (${val.reserved}/${val.count}) ${_price}`}
                                        </span>
                                      );
                                    else
                                      return (
                                        <span key={idx} style={{ color: "#888" }}>
                                          <br />
                                          <strike>{`${val.name} (${val.reserved}/${val.count}) ${_price}`}</strike>
                                        </span>
                                      );
                                  })}
                              </>
                            );
                            // "name": "텐트패키지",
                            // "price": 0,
                            // "count": 15,
                            // "reserved": 0,
                          }
                        }}
                      />
                    </React.Fragment>
                  </div>
                </div>

                <Toaster position="top-center" />
              </CardBody>
            </Card>

            <Card className="reservation-calendar-row-card">
              <CardBody>
                <div className="reservation-calendar-row-card__content">
                  <div className="reservation-calendar-row-card__summary">
                    <span className="reservation-calendar-row-card__date">{selectedDateText}</span>
                    <span className="reservation-calendar-row-card__count">예약 상품 {selectedDatePackages.length}개</span>
                  </div>
                  <div className="reservation-calendar-row-card__actions">
                    {!!isCancelable ? (
                      <Button className="btn btn-dark" onClick={handleDeleteCancelDay}>
                        <i className="ri-arrow-go-back-line me-1"></i>
                        우천취소 되돌리기
                      </Button>
                    ) : (
                      <Button
                        className="btn btn-secondary"
                        onClick={() => {
                          setCancelDayModal(true);
                        }}
                      >
                        <i className="ri-cloudy-2-line me-1"></i>
                        우천취소
                      </Button>
                    )}
                    <Button
                      color="primary"
                      onClick={() => handleBulkOffDay(true)}
                      disabled={bulkOffdayLoading !== null || isPastSelectedDate || !selectedDatePackages.length}
                    >
                      {bulkOffdayLoading === "block" ? <Spinner size="sm" className="me-1" /> : <i className="ri-lock-line me-1"></i>}
                      전체 예약 막기
                    </Button>
                    <Button
                      color="soft-secondary"
                      onClick={() => handleBulkOffDay(false)}
                      disabled={bulkOffdayLoading !== null || isPastSelectedDate || !selectedDatePackages.length}
                    >
                      {bulkOffdayLoading === "unblock" ? <Spinner size="sm" className="me-1" /> : <i className="ri-lock-unlock-line me-1"></i>}
                      예약 막음 풀기
                    </Button>
                  </div>
                </div>
              </CardBody>
            </Card>

            {reservDatas[moment(value).format("YYYY-MM-DD")]
              ? reservDatas[moment(value).format("YYYY-MM-DD")]
                .sort((a, b) => {
                  if (!a.price) return 1;
                  try {
                    return a.name.localeCompare(b.name); // Then sort by name
                  }
                  catch (e) {
                    return 0; // Fallback to no sorting if comparison fails
                  }
                })
                .map((val, idx) => {
                  return (
                    <SubCardTable
                      key={`reservations-table-${moment(value).format("YYYY-MM-DD")}-${val.id}`}
                      today={today}
                      packageCount={val.count}
                      packageReserved={val.reserved}
                      packageId={val.id}
                      packageTitle={val.name}
                      packagePrice={val.price}
                      allowFreeBooking={val.allow_free_booking}
                      targetDate={value}
                      targetDateText={moment(value).format("YYYY-MM-DD")}
                      offdayRefreshKey={offdayRefreshKey}
                    />
                  );
                })
              : null}
          </Col>
        </Row>
      </Container>

      <Modal isOpen={cancelDayModal} onClose={cancelDayModalToggle} centered={true} className="modal-dialog-centered modal-lg">
        <ModalHeader toggle={cancelDayModalToggle}>당일취소 허용설정</ModalHeader>
        <ModalBody>
          <Row>
            <label className="form-label" style={{ width: "100px" }}>
              취소사유
            </label>
            <Input type="text" className="form-control" style={{ maxWidth: "500px" }} value={cancelReason} onChange={(e) => setCancelReason(e.target.value)} />
          </Row>
          <div style={{ display: "flex", flexDirection: "row", marginBottom: "8px", justifyContent: "flex-start", alignItems: "center" }}>
            <div style={{ width: "100px" }}></div>
            <div>우천취소, 시설관련, 수영장 정비, 기타취소</div>
          </div>
          <Row style={{ marginBottom: "8px" }}>
            <label className="form-label" style={{ width: "100px" }}>
              제목
            </label>
            <Input type="text" className="form-control" style={{ maxWidth: "500px" }} value={cancelTitle} onChange={(e) => setCancelTitle(e.target.value)} />
          </Row>
          <Row style={{ marginBottom: "8px" }}>
            <label className="form-label" style={{ width: "100px" }}>
              팝업내용
            </label>
            <div style={{ marginLeft: "-12px", maxWidth: "524px" }}>
              <span style={{ color: "grey" }}>*내용을 비울 경우 기본 내용이 사용됩니다.</span>
              <MyEditor uid={moment(value).format("YYYY-MM-DD")} noImage={true} value={cancelDescription} width={"524px"} onChange={(e) => setCancelDescription(e)} />
            </div>
          </Row>
          <div style={{ display: "flex", flexDirection: "row", marginBottom: "8px", justifyContent: "flex-start", alignItems: "center" }}>
            <div style={{ width: "100px" }}>&nbsp;</div>
            <Button
              className="btn btn-light"
              onClick={() => {
                setCancelDescription("");
                setCancelReason("");
                setCancelTitle("");
                setCancelButtonName("");
              }}
            >
              내용초기화
            </Button>
            <div style={{ width: "12px" }}>&nbsp;</div>
            <Button
              className="btn btn-light"
              onClick={() => {
                setCancelDescription(`<p>[${moment(value).format("YYYY-MM-DD")}] 우천안내</p>
                <p>안녕하세요, 고객님! 어메이징캠프는  우천시에도 정상운영합니다. </p>
              <p>단, 우천으로 인해 취소를 원하시면 예약 당일 오전 10시 이전까지 마이페이지 구매내역에서 직접 취소하시면 100% 환불 가능합니다.</p>
              <p>(예약당일 오전 10시 이후로는 예약 취소가 불가능하오니, 이 점 꼭 참고해 주시기 바랍니다.)</p>
              <br />
              <p>*어메이징캠프 환불정책</p>
              <p>-이용일 3일전: 100% 자동환불<br />
              -이용 이틀전 : 70% 환불(30%차감)<br />
              -이용 하루전: 50% 환불<br />
              -이용 당일 : 환불불가<br />
              -당일 우천 시 이용가능하나, 취소 희망 시</p><br />
              
              <p>본 메세지는 우천 시 발송되는 메시지입니다. </p>`);
                setCancelReason("우천취소");
                setCancelTitle("당일 우천취소 안내");
                setCancelButtonName("우천취소");
              }}
            >
              우천취소 템플릿
            </Button>
            <div style={{ width: "12px" }}>&nbsp;</div>
            <Button
              className="btn btn-light"
              onClick={() => {
                setCancelDescription(`<p>[어메이징캠프 긴급알림]</p>
              <p>예약 고객님들에게 안내드립니다.</p>
              <p>갑작스러운 수영장 여과기 전기차단으로 인해 06/19(월)~06/21(수) 수영시설 이용이 불가합니다. 어메이징캠프팀은 고객님들의 편안하고 쾌적한 이용 환경을 최우선으로 생각하고 있기 때문에, 일시적 중단을 결정하였습니다. 갑작스런 시설 이용에 불편을 드린 점 사과 드립니다.</p>
              <p>***단, 이용 고객님들을 위해 간이 수영장이 설치되어 있으며, 간이수영장은 이용가능하십니다. </p>
              <p>*환불방법<br />
              해당일에 이용 고객님들은 예매사이트>마이페이지>예약내역을 직접 취소 하시면 예약당일 오전10시까지 100%환불 가능하십니다.</p>
              <p>*환불가능시간<br />
              -알림발송후~예약 이용 당일 오전 10시까지<br />
              -예약당일 오전10시까지 환불을 못 하신 분들은 어메이징캠프 카카오톡 채널로 문의주시면 환불 도와드리겠습니다.</p>
              <p>이용에 불편드려 다시 한번 진심으로 사과드리며, 고객님들의 편안하고 쾌적한 시설 이용을 제공하기 위해 최선을 다하겠습니다.</p>
              <p>감사합니다.</p>`);
                setCancelReason("수영장 정비");
                setCancelTitle("긴급알림");
                setCancelButtonName("기타취소");
              }}
            >
              긴급알림 템플릿
            </Button>
          </div>
          <Row>
            <label className="form-label" style={{ width: "100px" }}>
              취소버튼 이름
            </label>
            <Input type="text" className="form-control" style={{ maxWidth: "500px" }} value={cancelButtonName} onChange={(e) => setCancelButtonName(e.target.value)} />
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="dark" onClick={cancelDayModalToggle}>
            닫기
          </Button>
          <Button
            className="btn btn-secondary"
            onClick={() =>
              addRainCancelDay(moment(value).format("YYYY-MM-DD"), cancelReason, cancelButtonName, cancelTitle, cancelDescription).then((data) => {
                console.log("cancel day added:", data);
                if (data) setIsCancelable(data);
                cancelDayModalToggle();
              })
            }
          >
            {moment(value).format("YYYY-MM-DD")} 취소설정 저장
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default ReservationCalendar;
